import { Navigate } from "react-router-dom";

import Charlie from "@/components/charlie/Charlie";
import { useCharlieProvider } from "@/components/charlie/data/charlieApi";
import { useCharlieEnabled } from "@/config/featureFlags";

/**
 * Charlie route. Gated on the same account flag as the nav entry, so an account
 * without the feature can't reach the screen by typing the URL — it lands back
 * on the Operating View instead.
 */
const CharlieInsightPage = () => {
  const enabled = useCharlieEnabled();
  // The live feed, with the mock still behind the payor board. The hook runs
  // before the guard returns so hook order stays stable across both branches.
  const provider = useCharlieProvider();
  if (!enabled) return <Navigate to="/dashboard-insight" replace />;
  return <Charlie provider={provider} />;
};

export default CharlieInsightPage;
